export default __webpack_public_path__ + "static/media/flag-es-ES.d4167f87.svg";